import { css } from "@emotion/react";
import { useTitle } from "../../hooks/useTitle";
import { FrjTagGrid } from "./FrjTagGrid";
import { Link } from "react-router";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { frjBanner, frjNavLink } from "../../bits/frjUtils";

export const FrjArticles = () => {
  useTitle("FRJ Articles | Compass");

  return (
    <>
      <div css={frjBanner}>Annotate articles and cases in the FRJ</div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 24px;
          gap: 8px;
        `}
      >
        <FrjTagGrid />
        <div
          css={css`
            height: 1px;
            border: solid 1px rgba(0, 31, 43, 0.1);
            width: 100%;
            margin-top: 12px;
          `}
        ></div>
        <Link
          to="/frj/tags"
          css={[
            frjNavLink,
            css`
              display: flex;
              align-items: center;
              gap: 4px;
            `,
          ]}
        >
          View more{" "}
          <ArrowForwardIcon
            css={css`
              width: 20px;
            `}
          />
        </Link>
      </div>
    </>
  );
};
